import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import TaskPreview from "../../../Components/TaskPreview";

export default function Day({ date, monthOffset, onTaskClicked, windowSize }) {
  const isInPast = moment().isAfter(moment(date));
  const isToday = moment().isSame(moment(date), "date");
  const thisMonth = moment()
    .add(monthOffset, "months")
    .isSame(moment(date), "month");
  const tasks = useSelector((state) =>
    state.tasks.filter(
      (t) => !t.complete && moment(t.date).isSame(moment(date), "date")
    )
  );
  return (
    <div
      onClick={(e) => {
        if (e.currentTarget != e.target) {
          return;
        }
        onTaskClicked({ date: date });
      }}
      style={{
        width: `${100 / 7}%`,
        height: "100%",
        backgroundColor: !thisMonth
          ? "#333"
          : isToday
          ? "#d9e7ff"
          : isInPast
          ? "#aaa"
          : "white",
        // overflowY: "auto",
        display: "flex",
        flexFlow: "column",
        cursor: "pointer",
        // backgroundColor: "green",
      }}
    >
      <div
        style={{ color: thisMonth ? "black" : "white" }}
        onClick={(e) => {
          onTaskClicked({ date: date });
        }}
      >
        {moment(date).date()}
      </div>

      {tasks.map((t) => (
        <TaskPreview
          task={t}
          showDate={false}
          onClick={onTaskClicked}
          oneLine
        />
      ))}
    </div>
  );
}
